import { EventEmitter, Injectable, Output } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs'
import 'rxjs/Rx';

import { tRegistrationInfo, tLoginInfo, tLoginToken, tValidateTokenRes } from './glowadmin.typings';
import { ConfigService } from '../app-config.service';
import { CacheService } from './cache.service';
/*
 * Missing Functionality:
 *  - addAccount 
 */

@Injectable()
export class GlowAuthService {
  getAuthEvent: EventEmitter<any> = new EventEmitter();
  jwtHelper: JwtHelperService = new JwtHelperService();

  private url: string;  // Check CORS?
  private applicationId: string;
  private authKeyword: string;
  private userType: string;

  constructor(
    private http: Http,
    private cacheService: CacheService,
    private configService: ConfigService) {

    var configuration = this.configService.loadAdminConfig()
    this.url = configuration.environment.baseEndpoint
    this.authKeyword = configuration.environment.authKeyword
    this.userType = configuration.environment.userType
  }

  public register(user: tRegistrationInfo): Observable<any> {
    console.log('Register user');

    user.applicationId = this.applicationId;

    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.url + 'devuser', user, { headers: headers })
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => Observable.throw(error.json().error || 'create: Server error'));
  }

  public login(accountInfo: tLoginInfo): Observable<boolean> {

    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('applicationId', this.applicationId);

    //if we are using a functional group for authentication, add it to the headers
    console.log("logging in");

    return this.http.post(this.url + this.authKeyword + '/', JSON.stringify(accountInfo), { headers: headers })
      .map((res: Response) => this.saveJwt(res.json()))
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  public validateToken(): Observable<tValidateTokenRes> {

    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('token', localStorage.getItem('id_token'));

    //if we are using a functional group for authentication, add it to the headers
    console.log("validateToken");

    return this.http.get(this.url + this.authKeyword + '/', { headers: headers })
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  public logout() {
    // To log out, delete token from server side, and remove the token and profile from local Storage
    console.log("Logging Out")
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('applicationId', this.applicationId);
    headers.append('token', localStorage.getItem('id_token'));
    this.deleteJwt();
    this.deleteStorageData();
    return this.http.delete(this.url + this.authKeyword + '/deleteToken', { headers: headers })
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  public verify(verificationInfo) {
    console.log("Verifying Account")
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');

    verificationInfo.applicationId = this.applicationId;

    return this.http.put(this.url + this.userType + '/verify', verificationInfo, { headers: headers })
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  public generateVerificationToken(generateVerificationInfo) {
    console.log("Generate Verification Token")
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');

    generateVerificationInfo.applicationId = this.applicationId;

    return this.http.post(this.url + this.userType + '/verify', generateVerificationInfo, { headers: headers })
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  public resetPassword(resetPasswordInfo) {
    console.log("Password Reset")
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');

    resetPasswordInfo.applicationId = this.applicationId;

    return this.http.put(this.url + this.userType + '/resetpassword', resetPasswordInfo, { headers: headers })
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  public generatePasswordResetToken(generateResetPasswordInfo) {
    console.log("Generate Password Reset Token")
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');

    generateResetPasswordInfo.applicationId = this.applicationId;

    return this.http.post(this.url + this.userType + '/resetpassword', generateResetPasswordInfo, { headers: headers })
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  public changePassword(changePasswordInfo) {
    console.log("Change Password")
    let headers: Headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('applicationId', this.applicationId);
    headers.append('token', localStorage.getItem('id_token'));

    return this.http.post(this.url + this.userType + '/changepassword', changePasswordInfo, { headers: headers })
      .map((res: Response) => {
        return res.json();
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  public checkExistingToken(): boolean {
    console.log('checkExistingToken');
    let isTokenValid = false
    let token = localStorage.getItem('id_token');

    if (token) {
      console.log('Found token');
      // console.log(this.jwtHelper.decodeToken(token));
      console.log(this.jwtHelper.getTokenExpirationDate(token));
      // console.log(this.jwtHelper.isTokenExpired(token));
      if (this.jwtHelper.isTokenExpired(token) == false) {
        console.log('Token good');
        isTokenValid = true
      }
    }
    console.log('isTokenValid: ' + isTokenValid);
    return isTokenValid

  }

  public isAuthenticated(): Observable<boolean> {
    let isAuthenticated = this.checkExistingToken()
    if(isAuthenticated === false){
      this.deleteJwt();
    }
    return of(isAuthenticated);
  }

  checkValidateExistingToken(): void {

    let validToken = this.checkExistingToken()
    if (validToken === true) {
      this.validateToken()
        .subscribe(validToken => {
          console.log('Validate Token Response')
          console.log(validToken)
          if (validToken && validToken.hasOwnProperty('valid') && validToken.valid == true) {
            
          } else {
            this.getAuthEvent.emit("login");
            this.emitLoggingOut();
          }
        }, error => {
          var emitLogOut = true;
          // Do not emit logout if there is a network error.
          if (error && error.hasOwnProperty('messages') && Array.isArray(error.messages) && error.messages.length > 0) {
            for (var i = 0; i < error.messages.length; i++) {
              if (error.messages[i] == 'ERROR_NO_NETWORK') {
                emitLogOut = false
              }
            }
            if (emitLogOut === true) {
              console.warn('Token Validity Check Error : ' + error);
              this.emitLoggingOut();
            }
          }
        });
    } else {
      this.emitLoggingOut();
    }
  }

  private emitLoggingOut() {
    this.deleteJwt();
    this.getAuthEvent.emit("logout");
  }

  private saveJwt(data: any) {

    if (data.valid === true) {
      console.log('got a token and storing JWT locally');
      localStorage.setItem('id_token', data.token);
      localStorage.setItem('id', data.internalUserId);
      localStorage.setItem('organizationId', data.organizationId);
      localStorage.setItem('name', data.name);
      // if the data contains userGroups save them to the local storage
      if (data.userGroups) {
        localStorage.setItem('userGroups', JSON.stringify(data.userGroups));
      }
      this.getAuthEvent.emit("login");
      return true;
      // }

    }
    return false;

  }

  //removes token, name and accountId from localStorage
  //reomoves ve
  private deleteJwt() {
    console.log("delete JWT token  and everything elese from local storage")
    // localStorage.removeItem('id');
    // localStorage.removeItem('id_token');
    // localStorage.removeItem('name');
    // localStorage.removeItem('ve');
    localStorage.clear();

    return;

  }

  private deleteStorageData() {
    console.log("Deleting cached data");
    this.cacheService.clear();
  }

}